import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal, ModalHeader, ModalBody, Container, Row, Col } from "reactstrap";
import Slider from "react-slick";
import moment from "moment";
import classNames from "classnames";

import { getCacheImage } from "../../config";
import {
  ORDER_MASUK,
  _SELLER_SENT,
  _DONE_BY_ADMIN,
  _DONE_BY_BUYER,
  _DONE_BY_CRON,
  _KA_RECEIVED,
  _VERIFIED_PASS,
  _SENT_BUYER,
  _VERIFIED_FAIL,
  _ON_CANCEL,
  _KA_RETURN,
  _NEW,
  SENT_KICK,
  WAREHOUSE,
  ON_DONE,
  DISBURSEMENT,
  ADMINISTRATOR,
  emptyImage
} from "../../utils";

import Thumbnails from "../PageProductDetails/Detail/Thumbnails";
import CloseIcon from "../../images/close-button-search.png";
import emptySneakerImg from "../../images/emptysneakers2.png";
import { normalizeBrand } from "../../utils/Helpers";
import { getCloudImageUrl } from "../../utils";

class ModalDetailProcess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      available: true,
      hasMoreData: false,
      currentIndex: 0
    };
  }

  _getStatusProcessRiwayat = ({
    id,
    status,
    seller_responded,
    money_disbursed
  }) => {
    switch (status) {
      // case _NEW[0]: return seller_responded ? SENT_KICK : this._renderButton(seller_responded, id)
      case _NEW[0]:
        return seller_responded ? SENT_KICK : "Order Masuk";
      case _SELLER_SENT[0]:
        return WAREHOUSE;
      case _KA_RECEIVED[0]:
        return _KA_RECEIVED[1];
      case _VERIFIED_PASS[0]:
        return _VERIFIED_PASS[1];
      case _SENT_BUYER[0]:
        return _SENT_BUYER[1];
      case _DONE_BY_ADMIN:
        return money_disbursed ? ON_DONE : DISBURSEMENT;
      case _DONE_BY_BUYER:
        return money_disbursed ? ON_DONE : DISBURSEMENT;
      case _DONE_BY_CRON:
        return money_disbursed ? ON_DONE : DISBURSEMENT;
      case _VERIFIED_FAIL[0]:
        return _VERIFIED_FAIL[1];
      case _ON_CANCEL[0]:
        return _ON_CANCEL[1];
      case _KA_RETURN[0]:
        return _KA_RETURN[1];
      default:
        return ADMINISTRATOR;
    }
  };

  _getStatusArray(dataSale) {
    const rules = [
      "ORDER_CREATED",
      "SELLER_CONFIRMED",
      "SELLER_SENT",
      // "KA_RECEIVED",
      // "VERIFICATION_PASSED",
      "KA_SENT_BUYER"
    ];
    const orderStatus = ["KA_RECEIVED", "VERIFICATION_PASSED"].includes(
      dataSale.status
    )
      ? "KA_SENT_BUYER"
      : dataSale.status;
    return rules.map(str => {
      switch (str) {
        case "ORDER_CREATED":
          return {
            name: ORDER_MASUK[1],
            date:
              dataSale.seller_responded === null
                ? dataSale.seller_responded
                : dataSale.created_at,
            status:
              orderStatus === "NEW" && dataSale.seller_responded === null
                ? "CURRENT"
                : dataSale.seller_responded
                ? "PASSED"
                : "DISABLED"
          };
        case "SELLER_CONFIRMED":
          return {
            name: "Seller Accepted",
            date: dataSale.seller_responded,
            status: dataSale.seller_responded !== null ? "PASSED" : "DISABLED"
          };
        case "SELLER_SENT":
          return {
            name: WAREHOUSE[1],
            date: dataSale.ka_received,
            status:
              orderStatus === "SELLER_SENT" ||
              (orderStatus === "NEW" &&
                !dataSale.seller_sent &&
                dataSale.seller_responded !== null)
                ? "CURRENT"
                : dataSale.seller_sent
                ? "PASSED"
                : "DISABLED"
          };
        // case "KA_RECEIVED": return {
        //   name: _KA_RECEIVED[1],
        //   date: dataSale.ka_verified_date,
        //   status: orderStatus === "KA_RECEIVED" && dataSale.ka_verified_date === null ? "CURRENT": (
        //     dataSale.ka_verified_date && dataSale.ka_verified? "PASSED": "DISABLED"
        //   )
        // }
        // case "VERIFICATION_PASSED": return {
        //   name: _VERIFIED_PASS[2],
        //   date: dataSale.ka_verified_date,
        //   status: orderStatus === "VERIFICATION_PASSED" && dataSale.ka_verified_date !== null ? "PASSED": (
        //     dataSale.ka_sent ? "PASSED": "DISABLED"
        //   )
        // }
        case "KA_SENT_BUYER":
          return {
            // name: _SENT_BUYER[2],
            name: _SENT_BUYER[3],
            date: dataSale.customer_received,
            status:
              orderStatus === "KA_SENT_BUYER" &&
              dataSale.customer_received === null
                ? "CURRENT"
                : dataSale.customer_received
                ? "PASSED"
                : "DISABLED"
          };
      }
    });
  }

  navigateToProductDetails = data => {
    const categoryUrl =
      data.category_name === "apparels" || data.category_name === "Apparels"
        ? "apparel"
        : data.category_name === "handbags"? "luxury" : data.category_name;
    this.props.history.push(
      `/${categoryUrl}/${data.product_variant_id}/${data.product_variant.slug}`
    );
  };

  render() {
    const { sale_product } = this.props.dataSale;

    const imageUrl = sale_product && sale_product.image_url;

    const StatusTrue = this._getStatusArray(this.props.dataSale).filter(
      item => item.status !== "DISABLED"
    );
    let initialSlide = 0;
    StatusTrue.forEach((item, index) => {
      if (
        item.status === "CURRENT" ||
        (item.name === _VERIFIED_PASS[2] && item.status === "PASSED")
      ) {
        initialSlide = index;
      }
    });
    const currentStage = StatusTrue.for;
    const previewSettings = {
      arrows: true,
      infinite: false,
      fade: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // initialSlide: StatusTrue.length
      initialSlide
    };
    const onErrorImg = (e) => {
      e.target.src = emptyImage(sale_product && sale_product.category_name)
    }

    return (
      <Modal isOpen={this.props.isOpen} className="kick-modal detail-selling" toggle={this.props.onToggle}>
        <Container id="payment">
          <ModalHeader id="header-detail-sell" style={{ paddingBottom: 0 }}>
            <div onClick={this.props.onToggle}>
              <KickImage src={CloseIcon} />
            </div>
          </ModalHeader>
          <div className="consignment-approved">
            <div className="ca-sections">
              <span>Order ID:</span>
              <span>{this.props.dataSale.invoice_number}</span>
            </div>
          </div>
          <ModalBody>
            <Row>
              <Col>
                <div className="wrapper-image">
                  <KickImage
                    src={imageUrl? getCloudImageUrl(imageUrl, 400) : emptyImage(sale_product && sale_product.category_name)}
                    onError={(e) => onErrorImg(e)}
                  />
                </div>
                <div className="wrapper-image title">
                  <span>
                    {normalizeBrand(sale_product && sale_product.brand_name)}
                  </span>
                  <span
                    onClick={() => this.navigateToProductDetails(sale_product)}
                  >
                    {sale_product && sale_product.display_name}
                  </span>
                  <span>{sale_product && sale_product.SKU}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="wrapper-status">
                  <Slider {...previewSettings}>
                    {StatusTrue.map((item, index) => {
                      return (
                        <div key={index}>
                          <div className="date-status">
                            <span>
                              {item.date
                                ? moment(item.date).format("DD/MM/YYYY")
                                : null}
                            </span>
                            <span>{item.date !== null ? "DONE" : null}</span>
                          </div>
                          <div
                            className={classNames("border-status", {
                              "non-border": item.date === null
                            })}
                          >
                            <p>
                              {item.status === "CURRENT"
                                ? "CURRENT STATUS"
                                : "STATUS"}
                            </p>
                            <span>{item.name}</span>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="detail-process">
                <p>
                  Please consistently check your emails and notifications to
                  receive any informations regarding your package.
                </p>
              </Col>
            </Row>
          </ModalBody>
        </Container>
        {/* {this.getIndexStatus()} */}
      </Modal>
    );
  }
}

export default ModalDetailProcess;
